var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconawesomeBed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.464,
    height: 12.878,
    viewBox: "0 0 21.464 12.878",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-bed",
    "data-name": "Icon awesome-bed",
    d: "M5.9,10.939A2.683,2.683,0,1,0,3.22,8.256,2.686,2.686,0,0,0,5.9,10.939ZM17.708,6.646H10.2a.536.536,0,0,0-.537.537v4.829H2.146V5.037A.536.536,0,0,0,1.61,4.5H.537A.536.536,0,0,0,0,5.037V16.842a.536.536,0,0,0,.537.537H1.61a.536.536,0,0,0,.537-.537v-1.61H19.317v1.61a.536.536,0,0,0,.537.537h1.073a.536.536,0,0,0,.537-.537V10.4A3.756,3.756,0,0,0,17.708,6.646Z",
    transform: "translate(0 -4.5)",
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeBed);
export default __webpack_public_path__ + "static/media/Icon awesome-bed.d65be7b0558649620817929a856c43ba.svg";
export { ForwardRef as ReactComponent };